import React, { useState, useEffect } from 'react';
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { API_URL } from "../../../../constants/index";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";

const LeaveList = () => {
    const dispatch = useDispatch();
    useEffect(() => {
      dispatch(updateNavbarHeading("Leave"));
    }, []);
      const navigate = useNavigate();
  const [leave, setLeave] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
   const [apiStatus, SetApiStatus] = useState(undefined);


  const columns = {
    Code: { text: "Code", visible: true  },
    Name: { text: "Name" , visible: true },
    Description: { text:"Description", visible: true  },
    EvidenceDescription: { text:"Evidence Description", visible: true  }
  };
  const fetchLeaveList = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}leaves-list`);
            SetApiStatus(response?.status);
      if (response.status === 200) {
        const LeaveData = response?.data?.header;        
        setLeave(LeaveData);
      } else {
        console.error(
          "Failed to fetch Leave. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Leave:", error);
    }
  };
  useEffect(() => {
    fetchLeaveList();
  }, []);

  const handleAddNewAttendance = () => {
    navigate('/leave-list/add'); 
  };

  const handleEdit = (item) =>{
    navigate('/leave-list/edit/'+item.ID); 
  }

  return (
    <>
        <div className="container-fluid" id="skill_section">
          <div className="container-fluid" id="skill-table-area">
            <div className="row">
            <Dynamic_PR_table
                data={leave}
                columns={columns}
                itemsPerPage={8}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                showIcon1={true}
                isAddNewBtnRequired={true}
                handleIcon1={handleEdit}
                      isApiStatus={apiStatus}
              isRequiredStatus={true}
                handleAddNew={handleAddNewAttendance}
                isActionRequired={true}
                isSorting={true}
                icons={{
                  Icon1: <i class="bi bi-pencil-square"></i>,
                }}
              />
            </div>
          </div>
        </div>
    </>
  )
}

export default LeaveList;